import { render, staticRenderFns } from "./InterativeComponent.vue?vue&type=template&id=2bc79433"
import script from "./InterativeComponent.vue?vue&type=script&lang=js"
export * from "./InterativeComponent.vue?vue&type=script&lang=js"
import style0 from "./InterativeComponent.vue?vue&type=style&index=0&id=2bc79433&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports